module.exports = __webpack_public_path__ + "media/images/xpass/markers/active/bft-ac3cb59bcc7457aae72973d5007bbb40.png";